import API from "../api/api";
const $API = new API();

export async function downloadDocument(url, name) {
  if (!url || !url.includes("https://md-booking.hmc.co.il/")) return;
  try {
    const res = await $API.getDocApp(url);

    const link = document.createElement("a");
    link.href = res.message;
    link.download = name;

    const isMobile = window.innerWidth < 1200;
    if (isMobile && navigator.userAgent != "hmcAppUserAgent") {
      const response = await fetch(res.message);
      const blob = await response.blob();
      link.href = URL.createObjectURL(blob);
    }

    link.target = "_blank";
    link.click();
  } catch (error) {
    return error;
  }
}

export const emptySurgeryDocs = [
  {
    type: "clinic-confirm-agreement",
    files: [],
    title: "הסכמה מדעת לפעולה*"
  },
  {
    type: "reference-document",
    files: [],
    title: "סיכום ייעוץ לקראת ניתוח*"
  },
  {
    type: "ext-imaging-diagnosis",
    files: [],
    title: "פענוח בדיקות הדמייה"
  },
  { type: "", files: [], title: "קבצים נוספים" }
];

export const getSurgeryDocuments = async surgeryId => {
  const documents = JSON.parse(JSON.stringify(emptySurgeryDocs));
  const resDoc = await $API.getSurgeryDocuments(surgeryId);
  const docs = resDoc?.data?.data;
  if (!docs) return;

  docs.forEach(d => {
    const tmp = {
      id: d.id,
      name: d.file.file_name,
      path:
        "https://md-booking.hmc.co.il/ex-doctor/external" + d.file.full_path,
      type: d.type
    };

    if (d.type === "טופס הסכמה לפעולה חתום במרפאה") {
      documents[0].files.push(tmp);
    } else if (d.type === "הפניה קלינית של רופא") {
      documents[1].files.push(tmp);
    } else if (d.type === "פענוח דימות חיצוני") {
      documents[2].files.push(tmp);
    } else {
      documents[3].files.push(tmp);
      documents[3].type = d.type;
    }
  });

  return documents;
};
